import React, { useRef } from 'react';

// 999.999,99 € — anything beyond is ignored
const MAX_CENTS = 99999999;

const formatCents = (cents) =>
  (cents / 100).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

/**
 * Euro input with cash-register style entry:
 * typing digits shifts them in from the right (7 -> 0,07 | 5 -> 0,75 | 1 -> 7,51),
 * backspace shifts the rightmost digit out again.
 */
const AmountInput = ({ value, onChange, className = '', disabled = false }) => {
  const inputRef = useRef(null);

  const currentCents = Math.round((parseFloat(value) || 0) * 100);

  const moveCursorToEnd = (e) => {
    const len = e.target.value.length;
    e.target.setSelectionRange(len, len);
  };

  const handleChange = (e) => {
    // Interpret all remaining digits as cents
    const digits = e.target.value.replace(/\D/g, '');
    let cents = parseInt(digits || '0', 10);
    if (cents > MAX_CENTS) cents = currentCents;

    // Keep the DOM in sync even when the numeric value does not change
    // (e.g., typing a letter), since React skips re-rendering in that case
    const formatted = formatCents(cents);
    e.target.value = formatted;
    e.target.setSelectionRange(formatted.length, formatted.length);

    onChange(cents / 100);
  };

  return (
    <input
      ref={inputRef}
      type="text"
      inputMode="numeric"
      value={formatCents(currentCents)}
      onChange={handleChange}
      onFocus={moveCursorToEnd}
      onClick={moveCursorToEnd}
      onKeyUp={moveCursorToEnd}
      placeholder="0,00"
      className={className}
      disabled={disabled}
    />
  );
};

export default AmountInput;
